// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__Lcpmt","label":"SetPasswdForm_label__1gG16"};